
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  GetPatientList,
  GetSearchDictionary,
  GetSourceList,
  DelPatient,
} from "@/request/common";
import { GetIdArr } from "@/utils/base";
@Component({})
export default class Name extends Vue {
  private props: any = { multiple: true, value: "id" };
  private filter: any = {
    标签: [],
    来源: "",
    source: "",
    search: "",
    startTime: "",
    endTime: "",
    current_page: 1,
    page_count: 20,
    totalCount: 0,
    total_page: 0,
  };
  private biaoqianData: any = [
    {
      id: "jibingzhenduan",
      value: "疾病诊断",
      label: "疾病诊断",
      children: [],
    },
    {
      id: "jiwangshi",
      value: "既往史",
      label: "既往史",
      children: [],
    },
  ];
  private cpatient = 0;
  private list: any = [];
  private biaoqians: any = [];
  private sources: any = [];
  private content: any = {};
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private getBiaoqian() {
    this.biaoqianData.forEach((ele: any) => {
      const params: any = {
        params: {
          values: ele.value,
        },
      };
      GetSearchDictionary(this, params).then((res: any) => {
        ele.children = res.data;
      });
    });
  }
  private remoteSource(e: any) {
    const params: any = {
      params: {
        search: e || "",
        limit: 9999,
      },
    };
    GetSourceList(this, params).then((res: any) => {
      this.sources = res.data;
    });
  }
  private search() {
    this.filter.current_page = 1;
    this.getList();
  }
  private async fingerSearch() {
    console.log('指纹搜索');
    const loading = this.$loading({
      lock: true,
      text: "指纹验证中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const res = await window.electronMyAPI.checkFinger('search');
    loading.close();
    console.log(res);
    if (res.includes('success')) {
      // 返回结果success&cj2& ....,需要截取&和&之间的内容
      this.filter.search = res.split('&')[1];
      this.search();
    } else {
      this.$message.warning('指纹验证失败');
    }
  }
  private changeTab(part: any) {
    this.filter["签约状态"] = part;
    this.getList();
  }
  private selectPatient(item: any) {
    this.$store.commit("updatePatient", item);
  }
  private getList(part: any = "") {
    let source: any = GetIdArr(this.filter.source).join(",");
    let tag: any = [];
    // let tag: any = GetIdArr(this.filter["标签"], "value").join(",");
    this.filter["标签"].forEach((ele: any) => {
      tag.push(ele[1]);
    });
    // part 存在表示是触底加载下一页
    if (part) {
      if (this.filter.current_page === this.filter.total_page) {
        return;
      }
      this.filter.current_page++;
      const params: any = {
        params: {
          page: this.filter.current_page,
          search: this.filter.search,
          limit: 30,
        },
      };
      if (source) {
        params.params.source_ids = source;
      }
      if (tag) {
        params.params.tag = tag.join(",");
      }
      GetPatientList(this, params).then((res: any) => {
        this.list = this.list.concat(res.data);
        this.content = res;
        this.filter.totalCount = res.total;
        if (this.list.length > 0 && (!this.patient || !this.patient.id)) {
          this.selectPatient(this.list[0]);
        } else if (this.list.length == 0 && this.patient && this.patient.id) {
          this.selectPatient(this.patient);
        }
      });
    } else {
      const params: any = {
        params: {
          page: this.filter.current_page,
          search: this.filter.search,
          ordering: "-update_datetime",
          limit: 30,
        },
      };
      if (source) {
        params.params.source_ids = source;
      }
      if (tag) {
        params.params.tag = tag.join(",");
      }
      GetPatientList(this, params).then((res: any) => {
        this.list = res.data;
        this.content = res;
        this.filter.totalCount = res.total;
        if (this.list.length > 0 && (!this.patient || !this.patient.id)) {
          this.selectPatient(this.list[0]);
        } else if (this.list.length == 0 && this.patient && this.patient.id) {
          this.selectPatient(this.patient);
        }
      });
    }
  }
  private addPatient() {
    this.$router.push({
      path: "/main/manage/patient",
    });
  }
  private delPatient() {
    this.$confirm("您是否确定删除当前患者？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      DelPatient(this, this.patient.id, loading).then((res: any) => {
        loading.close();
        this.$store.commit("updatePatient", {});
        this.getList();
      });
    });
  }
  mounted() {
    this.getBiaoqian();
    this.getList();
  }
}
